module.exports = __webpack_public_path__ + "media/images/flags/32/Cote-dIvoire-3fb2a943df61ef5b53a069a7bc3c0c75.png";